import { Pausable } from '../../Utils/Pausable';
import { FocusManager } from '../../Managers/FocusManager';

export class AnimatedSprites extends Pausable {
    public get sprite() {
        return this.animated;
    }

    private readonly animated: PIXI.extras.AnimatedSprite;
    private readonly destroyOnComplete: boolean;
    private wasPlaying: boolean;

    constructor(scale: number, frames: PIXI.Texture[], destroyOnComplete = true) {
        super();
        const anim = new PIXI.extras.AnimatedSprite(frames);
        anim.alpha = 0;
        anim.scale.set(scale);
        anim.anchor.set(0.5);
        anim.animationSpeed = 0.5;
        anim.loop = false;
        this.animated = anim;
        this.destroyOnComplete = destroyOnComplete;
    }

    public play(cb?: () => void) {
        this.animated.alpha = 1;
        this.animated.onComplete = () => {
            if (cb) {
                cb();
            }
            if (this.destroyOnComplete) {
                this.animated.destroy();
                this.destroy();
            } else {
                this.animated.alpha = 0;
            }
        };
        this.animated.play();
    }

    public setScale(scale: number) {
        this.animated.scale.set(scale);
    }

    public destroy() {
        super.destroy();
        if (this.animated.parent) {
            this.animated.destroy();
        }
    }

    protected setPaused(paused: boolean) {
        if (paused && FocusManager.instance.hasFocus) {
            return;
        }
        if (paused) {
            this.wasPlaying = this.animated.playing;
            this.animated.stop();
        } else if (this.wasPlaying) {
            this.animated.play();
        }
    }
}
